var React = require('react');

function ArrowRightLargeInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M34.3037 17.9297L1.41822 17.9297","stroke":"#25F906","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M17.1756 35.0584L34.3512 17.8828L17.1756 0.7072","stroke":"#25F906","strokeWidth":"2","key":1})]);
}

ArrowRightLargeInline.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = ArrowRightLargeInline;

ArrowRightLargeInline.default = ArrowRightLargeInline;
